'use strict';
require('../modules/es.error.cause');
require('../modules/es.aggregate-error');
require('../modules/es.aggregate-error.cause');
require('../modules/es.array.iterator');
require('../modules/es.string.iterator');
var path = require('../internals/path');

module.exports = path.AggregateError;
